import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

export const onlyIngredientToggle = css`
  margin-top: 1rem;

  & > div:first-of-type {
    display: inline-flex;
    margin-left: -0.5rem;
  }
`;

export const clearAll = css`
  text-align: end;
`;

export const bold = css`
  font-weight: ${typography.weightSemiBold};
`;
